import { render } from "./Debugger.vue?vue&type=template&id=52861d53&scoped=true"
import script from "./Debugger.vue?vue&type=script&lang=js"
export * from "./Debugger.vue?vue&type=script&lang=js"

import "./Debugger.vue?vue&type=style&index=0&id=52861d53&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52861d53"]])

export default __exports__